/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAngleUp,
    faArrowLeft,
    faXmark,
    faArrowUpRightFromSquare,
    faToggleOff, faToggleOn
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import "./custom.scss";

import "./styles.scss";

import SOTable from "./SOTable";
import InTable from "./InTable";
import OutTable from "./OutTable";
import QCTable from "./QCTable";
import COMTable from "./ComTable";
import Editor from "./Editor";

import ModalPortal from "util/component/Modal";
import { Modal, Confirm, Rev, RevLog, ConfirmIndexDB } from "util/component/Modal/Modal";

import SearchableSelect from "util/component/SearchableSelect";

import update from "immutability-helper";
// import axios from 'util/axios';
import axios from 'util/axios';
import { useTranslation } from "react-i18next";

import FileDragDrop from "util/component/FileDropDown";

import Draggable from "react-draggable";
import RevData from "./DnDTables/RevTable";
import ComTextarea from "./DnDTables/ComTextarea";

import { validationSub, validationData, validationData2, readyValidationData } from "./save.js";
import UserList from "./DnDTables/UserList";
import CompleteList from "./DnDTables/CompleteList";
import openDatabase, { addStore, deleteDatabase, selectAll, truncateStore, calculateIndexDBSize, deleteAllDatabase } from "util/autoSave";
import { DownloadFile } from "util";

/*
ALL 용 init 값
*/
const FirstSOParam = { label: "ALL", code: null, desc: "ALL" };

const validationList = {
    master: ["plant", "mbrNo", "projectNm", "processCd", "unitCd", "cycle"],
};

const interValList = {
    master: ["plant", "processCd", "unitCd", "cycle"],
};

const CustomInput = (props) => {
    const dispatch = useDispatch();
    const [_value, _setValue] = useState(props.value);

    const _onChange = (e) => {
        let _val = e.target.value;
        if (props.name === "cycle") {
            _val = _val.toString().replace(/\D+/, "");
        }
        _setValue(_val);
    };

    const _onFocus = (e) => {
        try {
            dispatch({ type: "FOCUS_TD", td: _input.current });
        } catch (e) { }
    };
    const _onBlur = (e) => {
        if (props.name === "cycle" && e.target.value === "") {
            e.target.value = "1";
        }
        dispatch({ type: "BLUR_TD" });
        props.onChange(e);
    };
    const _input = useRef();

    useEffect(() => {
        _setValue(props.value);
    }, [props]);

    return (
        <input
            {...props}
            ref={_input}
            value={_value}
            onFocus={_onFocus}
            onBlur={_onBlur}
            onChange={_onChange}
            disabled={props.disabled}
        />
    );
};

/**
 *
 * @param {\} param0
 * Axios는 비동기 방식이기 때문에
 * response의 결과값을 받은 후의 작업을 then 안에서 써야한다.
 * 본래 자바스크립트는 원 쓰레드 형식이기 때문에
 * 비동기 방식을 사용하게 되면 병행성 처리랑 유사하기 때문에
 * then에서 데이터 값 받은 후 아래에 쓰면 가끔 값을 아예 못받을 때도 있다.
 * then을 벗어나서 쓰게 될 경우
 * API를 불러오는 진행 중에 then을 벗어난 코드를 이어서 순차적으로 진행하기 때문에 값이 덜 받아오거나
 * 심할 경우 값이 안받아온 상태에서 진행하여 res가 null 값으로 간주하여 진행할때도 있기 때문에 ERROR 표시가 나올 때도 있다.
 * 개발 서버 및 데이터처리가 적은 작업이라면 정상적으로 진행되는 경우가 많지만
 * 만일 DBMS 서버에서 처리량이 많아질 경우 작업이 밀리므로 일부 DB 정보만 받아와질 경우도 있고, 아예 안받아와지는 경우가 있다.
 * 개발자 도구상에서 API 값을 받아왔을때는 아무런 이상은 없지만, 비동기 방식 특성상 처리가 덜 된 상태로 나오기 때문에
 * 아래와 같이 then 안에 코드로 사용하는 것으로 대처하였다.
 * then 안에 사용하지 않았을 경우,
 * 또한 setTimeout(com_t(res['composition']), 100) 에서 100ms 후에 실행 조건이 붙어 있기 때문에
 * 미세한 시간차로 인해 가끔 전체는 잘 뜨는 대신 com 관련 DB가 불려오는게 밀려져서 화면상에 안뜨는 경우가 발생한다.
 * 문제 발생시 setTimeout 코드를 제거하고 해보는 것이 좋을 것 같은 사견입니다.
 */
let indexDBParam = "";
const getAxios = async ({ postData, master_t, sub_t, in_t, out_t, qc_t, com_t, revInfo, fileInfo, isCopy, userId }) => {

    try {
        await axios
            .post(process.env.REACT_APP_API + "/pcsCreate/retrieveSheetMaster", postData)
            .then((Response) => {
                const res = Response.data.data.result;
                if (!!!res || res.master === null) {
                    alert("ERROR");

                    window.history.go(-1);
                    return;
                }
                indexDBParam = res.master;
                let m = { ...res.master };
                if (isCopy === "Y") {
                    m = { ...m, projectNm: "", mbrNo: "", userId, readyYn: "N" };
                }
                // ALL이 앞에 올 경우 s = [FirstSOParam];
                let s = [];
                // Step Operation
                res.sub.forEach((v, i) => {
                    s = [
                        ...s,
                        {
                            ...v,
                            code: v.soCode,
                            label: v.soNm,
                            desc: v.description,
                            repeat: v.repeat,
                            // soSeq: v.soSeq,
                        },
                    ];
                });
                // s = [...s, FirstSOParam]
                master_t((v) => ({ ...v, ...m }));
                setTimeout(sub_t(s), 500);
                setTimeout(com_t({ data: res["composition"], header: res?.header }), 1000);
                setTimeout(in_t({ data: res["in"], header: res?.header, isCopy: isCopy }), 1200);
                setTimeout(out_t({ data: res["out"], header: res?.header, isCopy: isCopy }), 1400);
                setTimeout(qc_t({ data: res["qc"], header: res?.header }), 1600);
                revInfo(res.revision.maxRevision);
            })
            .catch((e) => console.error(e));
    } catch (e) {
        console.error(e);
    }
};

const Create = () => {
    const { t } = useTranslation(["page"]);
    const dispatch = useDispatch();
    const tdSelector = useSelector((store) => store.tdSelector);
    const [SOParams, SetSOParam] = useState([]);
    const [SelectedSO, SetSelectedSO] = useState(0);

    const [RevItem, SetRevItem] = useState(0);
    const [RevList, SetRevList] = useState([]);
    const [RevCmptCheckList, SetRevCmptCheckList] = useState([]);
    const [ConfirmDom, SetConfirmDom] = useState(null);
    const [ModalOpen, SetModalOpen] = useState(false);
    const [ModalMsg, SetModalMsg] = useState(<p></p>);
    const [WaitModal, SetWaitModal] = useState(null);
    const [TempSaveOpen, SetTempSaveOpen] = useState(false);
    const [ConfirmOpen, SetConfirmOpen] = useState(false);
    const [ConfirmOpen2, SetConfirmOpen2] = useState(false);
    const [RevOpen, SetRevOpen] = useState(false);
    const [RevLogOpen, SetRevLogOpen] = useState(false);
    const [menuOpenS, menuOpen] = useState(true);

    const [revModeCheck, setRevModeCheck] = useState(false);

    const [Review, SetReview] = useState(false);

    const quillRef = useRef(null);

    const FileDragDropRef = useRef(null);

    const [MasterOPTS, SetMasterOPTS] = useState({
        PLANT: null,
        PROJECT: null,
        MBRNO: null,
        STAGE: null,
    });

    const [Hide, SetHide] = useState(false);

    const [inputs, setInputs] = useState({
        sheetCode: "",
        plant: "",
        mbrNo: "",
        projectNm: "",
        processCd: "",
        unitCd: "",
        description: "",
        cycle: "1",
        revision: 0,
        webContent: "",
        stage: "",
        readyYn: "",
    });
    const [revInputs, setRevInputs] = useState({
        sheetCode: "",
        revision: "",
        uniqueCode: "",
        celNm: "",
        userId: "",
        sheetOwner: "",
        revContent: "",
        revLevel: "",
        tempYn: "",
        sheetType: "",
        groupId: "",
    });
    const [soSelected, setSoSelected] = useState({
        name: "",
        index: "",
    });

    const [sheetCompleteList, setSheetCompleteList] = useState([]);

    const [sheetCompleteState, setSheetCompleteState] = useState(false);

    const [revUserList, setRevUserList] = useState([]);
    const ScrollRef = useRef();

    const userSelector = useSelector((store) => store.user);
    const navigate = useNavigate();

    const HandleModalOpen = () => {
        SetModalOpen(!ModalOpen);
    };

    const HandleTempSaveOpen = () => {
        if (TempSaveOpen) {
            isUpdate2.current = true;
            copyRef.current = "N";

            window.location.replace("/mainForm?mid=" + mid.current + "&rev=" + rev.current + "&tempYn=" + tmp.current);
        }
        SetTempSaveOpen(!TempSaveOpen);
    };

    const confirmValid = () => {
        let valid = true;
        const el = document.getElementById("saveMsg");

        valid = !!el.value;
        if (!valid) {
            document.getElementById("mainFormSaveSpan").classList.remove("valid");
        }
        return valid;
    };

    const handleConfirmValid = () => {
        document.getElementById("mainFormSaveSpan").classList.add("valid");
    };

    const onConfirm = (close) => {
        let valid = confirmValid();

        if (valid) {
            const el = document.getElementById("saveMsg");
            close(valid);
            SaveFormData({ msg: el.value });
        }
    };

    const [isUpdate, setIsUpdate] = useState(false);
    const isUpdate2 = useRef(false);
    const mid = useRef("");
    const rev = useRef(0);
    const tmp = useRef("N");
    const copyRef = useRef("");
    const [remarkList, SetRemarkList] = useState([]);

    const [indexDB, setIndexDB] = useState(true);

    useEffect(() => {
        initialOptions();
        initialCreate().then(() => initialCreate2())
    }, []);

    const initialOptions = async () => {
        dispatch({ type: "LOADING_ON" });
        let res;
        const GRCD = ["PLANT", "PROJECT", "MBRNO", "STAGE"];
        let newOPTS = {};
        try {
            for (let i of GRCD) {
                res = await axios.post(process.env.REACT_APP_API + "/common/retrieveMasterCodeList", {
                    grcd: i,
                    disableYn: "N",
                });
                newOPTS[i] = res.data.data.result;
            }
            SetMasterOPTS(newOPTS);
        } catch (e) { }

        dispatch({ type: "LOADING_OFF" });
    };
    const handleClickSQTable = (col, index) => {
        setSoSelected({ name: col, index: index });
    };

    const selectRemark = (data, name) => {
        let ret = [];
        let remark = [];
        data.forEach((d, i) => {
            let uniqueCode = "";
            let remark2 = ""

            d.forEach((a, b) => {
                a.forEach((c, d) => {
                    if (c.name === 'uniqueCode')
                        uniqueCode = c.value;
                    if (c.name === 'remark' && c.value !== 'FALSE')
                        remark2 = c.value;
                });
                if (remark2?.length > 0) {
                    remark = [...remark, { name: name, uniqueCode: uniqueCode, value: remark2 }];
                }
                uniqueCode = "";
                remark2 = "";
            }
            );
            if (remark.length !== 0) {
                ret = remark;
            }
        });
        return ret;
    };

    const selectRemarkCom = (data, name) => {
        let ret = [];
        let uniqueCode = "";
        let remark2 = ""
        let remark = [];
        data.forEach((a, b) => {
            a.forEach((c, d) => {
                if (c.name === 'uniqueCode') {
                    uniqueCode = c.value;
                }
                if (c.name === 'remark' && c.value !== 'FALSE') {
                    remark2 = c.value;
                }
            });
            if (remark2?.length > 0) {
                remark = [...remark, { name: name, uniqueCode: uniqueCode, value: remark2 }];
            }
            uniqueCode = "";
            remark2 = "";
        });


        if (remark.length !== 0) {
            ret = remark;
        }
        return ret;

    };

    const updateRemarkList = (idx, data, type) => {

        let ret = [];
        ret = [...selectRemark(in_tbl.current.getTableData(), "in")];
        ret = [...ret, ...selectRemark(out_tbl.current.getTableData(), "out")];
        ret = [...ret, ...selectRemark(qc_tbl.current.getTableData(), "qc")];
        ret = [...ret, ...selectRemarkCom(com_tbl.current.getTableData(), "com")];
        SetRemarkList([...ret]);


    };

    const initialCreate2 = async () => {
        if (mid.current && rev.current && copyRef.current !== "Y") {
            dispatch({ type: "LOADING_ON" });
            await getRevCmptCheckList({
                sheetcd: mid.current,
                revision: rev.current,
                tempYn: tmp.current,
            });
            await getUserList({ sheetCode: mid.current });
            await getSheetCompleteList();
            dispatch({ type: "LOADING_OFF" });
        }
        let ret = [];
        ret = [...selectRemark(in_tbl.current.getTableData(), "in")];
        ret = [...ret, ...selectRemark(out_tbl.current.getTableData(), "out")];
        ret = [...ret, ...selectRemark(qc_tbl.current.getTableData(), "qc")];
        ret = [...ret, ...selectRemarkCom(com_tbl.current.getTableData(), "com")];
        SetRemarkList([...ret]);
    };
    const initialCreate = async () => {
        const isWriter = userSelector.isWriter || userSelector.isAdmin;
        if (!isWriter) {
            alert(t("writer"));
            navigate(-1);
        }
        const search = new URLSearchParams(window.location.search);
        mid.current = search.get("mid");
        rev.current = search.get("rev") || 0;
        copyRef.current = search.get("copy");
        tmp.current = search.get("tempYn") || "N";

        if (mid.current && rev.current) {
            dispatch({ type: "LOADING_ON" });
            isUpdate2.current = true;
            let sheetCode = ""
            if (copyRef.current === "Y") {
                sheetCode = "tempsheet"
            } else {
                sheetCode = mid.current;
            }

            const chk = await selectDB(sheetCode, {
                master_t: setInputs,
                sub_t: initialSO,
                in_t: in_tbl.current?.loadData,
                out_t: out_tbl.current?.loadData,
                qc_t: qc_tbl.current?.loadData,
                com_t: com_tbl.current?.loadData,
                revInfo: RevInfo,
                // fileInfo: SetFileInfo,
                isCopy: copyRef.current,
                userId: userSelector.userId
            })
            if (chk < 1) await getAxios({
                postData: {
                    sheetcd: mid.current,
                    revision: rev.current,
                    tempYn: tmp.current,
                },
                master_t: setInputs,
                sub_t: initialSO,
                in_t: in_tbl.current?.loadData,
                out_t: out_tbl.current?.loadData,
                qc_t: qc_tbl.current?.loadData,
                com_t: com_tbl.current?.loadData,
                revInfo: RevInfo,
                // fileInfo: SetFileInfo,
                isCopy: copyRef.current,
                userId: userSelector.userId,
            });

            let ret = [];
            ret = [...selectRemark(in_tbl.current.getTableData(), "in")];
            ret = [...ret, ...selectRemark(out_tbl.current.getTableData(), "out")];
            ret = [...ret, ...selectRemark(qc_tbl.current.getTableData(), "qc")];
            ret = [...ret, ...selectRemarkCom(com_tbl.current.getTableData(), "com")];
            SetRemarkList([...ret]);

            if (copyRef.current === "Y") {
                mid.current = "";
                rev.current = 0;
                RevInfo(0);
            } else {
                setIsUpdate(true);
            }
            dispatch({ type: "LOADING_OFF" });
        } else {
            const chk = await selectDB("tempsheet", {
                master_t: setInputs,
                sub_t: initialSO,
                in_t: in_tbl.current?.loadData,
                out_t: out_tbl.current?.loadData,
                qc_t: qc_tbl.current?.loadData,
                com_t: com_tbl.current?.loadData,
                revInfo: RevInfo,
                // fileInfo: SetFileInfo,
                isCopy: copyRef.current,
                userId: userSelector.userId
            })
            if (chk > 0) {
                let ret = [];
                ret = [...selectRemark(in_tbl.current.getTableData(), "in")];
                ret = [...ret, ...selectRemark(out_tbl.current.getTableData(), "out")];
                ret = [...ret, ...selectRemark(qc_tbl.current.getTableData(), "qc")];
                ret = [...ret, ...selectRemarkCom(com_tbl.current.getTableData(), "com")];
                SetRemarkList([...ret]);

                if (copyRef.current === "Y") {
                    mid.current = "";
                    rev.current = 0;
                    RevInfo(0);
                } else {
                    setIsUpdate(true);
                }
                dispatch({ type: "LOADING_OFF" });
            }
        }
        return 1;
    };

    const getSheetCompleteList = useCallback(async () => {
        const search = new URLSearchParams(window.location.search);
        const mid = search.get("mid");
        const rev = search.get("rev");
        const tmp = !!search.get("tempYn") ? search.get("tempYn") : "N";
        const copy = search.get("copy");

        if (copy === "Y") return;
        const response = await axios.post(process.env.REACT_APP_API + "/pcsReview/findCompleteList", {
            sheetCode: mid,
            revision: rev,
            tempYn: tmp,
        });
        if (response.status === 200) {
            const resultData = response.data.data.result;
            setSheetCompleteList(resultData);
        } else {
            throw new Error("getAxios");
        }
    });

    const getUserList = useCallback(
        async (data) => {
            const response = await axios.post(process.env.REACT_APP_API + "/pcsReview/retrieveCallUserList", data);

            const resultData = response.data.data.result;
            setRevUserList(resultData);
        },
        [revUserList]
    );

    const soRef = useRef(null);
    const initialSO = (d) => {
        soRef.current.setData(d, copyRef.current);
    };
    const [PRList, setPRList] = useState([]);
    useEffect(() => {
        axios
            .post(process.env.REACT_APP_API + "/common/retrieveMasterCodeList", {
                grcd: "PROC",
                disableYn: "N",
            })
            .then((Response) => setPRList(Response.data.data.result))
            .catch((e) => console.error(e));
    }, []);
    const [UOList, setUOList] = useState([]);
    const getUOList = async () => {
        axios
            .post(process.env.REACT_APP_API + "/common/retrieveMasterCodeList", {
                grcd: inputs.processCd,
                disableYn: "N",
            })
            .then((Response) => setUOList(Response.data.data.result))
            .catch((e) => console.error(e));
    }

    useEffect(() => {
        getUOList();
    }, [inputs.processCd]);

    useEffect(() => {
        SetSelectedSO(0);
    }, [inputs.unitCd]);

    const getRevCmptCheckList = useCallback(
        async (data) => {
            const response = await axios.post(process.env.REACT_APP_API + "/pcsReview/findRevCmptCheck", data);
            if (response.status === 200) {
                const resultData = response.data.data.result;
                SetRevCmptCheckList(resultData);

                const sheetReview = resultData !== undefined ? resultData.filter((sheet) => sheet.uniqueCode === "M") : undefined;
                const sheetData1 =
                    sheetReview !== undefined ? sheetReview.findIndex((key) => key.celNm === "description") : undefined;
                const sheetData2 = sheetReview !== undefined ? sheetReview.findIndex((key) => key.celNm === "cycle") : undefined;
                let cycle;
                let description;
                let cycleType;
                let descType;

                if (sheetData2 !== undefined && sheetReview[sheetData2] !== undefined && sheetData2 > -1) {
                    cycle = true;
                    cycleType = sheetReview[sheetData2].cmptType === "R" ? "#F84F31" : "#23c552";
                } else {
                    cycle = true;
                    cycleType = "#b3b3b3";
                }
                if (sheetData1 !== undefined && sheetReview[sheetData1] !== undefined && sheetData1 > -1) {
                    description = true;
                    descType = sheetReview[sheetData1].cmptType === "R" ? "#F84F31" : "#23c552";
                } else {
                    description = true;
                    descType = "#b3b3b3";
                }
            } else {
                throw new Error("getAxios");
            }
        },
        [RevCmptCheckList]
    );
    const onChangeInputHandler = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        let obj = { [name]: value };
        // URS 31번 : MBR No의 따라 자동 설정 기능 추가
        if (name === "mbrNo") {
            switch (value.substr(0, 1)) {
                case "M":
                case "C":
                case "H":
                    // processCd
                    if (inputs.processCd === "DSP") {
                        changeSOListner("init")
                        soRef.current.resetData();
                        setInputs((i) => update(i, { $merge: { unitCd: "" } }));
                    }
                    setInputs((i) => update(i, { $merge: { processCd: "USP" } }));
                    break;
                default: // B, P, G, U 일 경우

                    if (inputs.processCd === "USP") {
                        changeSOListner("init")
                        soRef.current.resetData();
                        setInputs((i) => update(i, { $merge: { unitCd: "" } }));
                    }

                    setInputs((i) => update(i, { $merge: { processCd: "DSP" } }));
            }
        } else if (name === "unitCd") {
            if (copyRef.current === "Y") {
                isUpdate2.current = false;
            }
        }
        // URS 31번 끝.
        if (name === "processCd" && value === "USP") {
            obj = { ...obj, cycle: "1" };
            soRef.current.resetData();
        }
        if (name === "processCd" && value !== "USP") {
            obj = { ...obj, stage: "" };
            soRef.current.resetData();
        }

        setInputs((i) => update(i, { $merge: { ...obj } }));

    };

    const bugCheck = useRef(0);
    const bugCheckFunc = useRef(null);

    useEffect(() => { }, [SOParams]);

    const changeSO = (data) => {
        if (data.length <= SelectedSO) {
            SetSelectedSO(data.length);
        } else if (SOParams.length - 1 === SelectedSO && SelectedSO !== 0) {
            SetSelectedSO((SSO) => SOParams.length);
        }

        clearTimeout(bugCheckFunc.current);
        if (data.length < 1 && isUpdate2.current) {
            bugCheck.current = bugCheck.current + 1;
            bugCheckFunc.current = setTimeout(() => {
                if (data.length < 1) {
                    // initialCreate().then(() => initialCreate2());
                }
            }, 500);
        }

        SetSOParam((SO) => [
            // FirstSOParam,
            ...data,
            FirstSOParam,
        ]);
    };

    const remarkSO = (data) => {
        SetSOParam((SO) =>
            update(SO, {
                [data.idx]: { $merge: { [data.type + "Remark"]: data.data } },
            })
        );
    };

    const changeSOListner = (action, obj) => {
        if (action === "init") {
            in_tbl.current.initial();
            out_tbl.current.initial();
            qc_tbl.current.initial();
            !!com_tbl.current && com_tbl.current.initial();
        } else if (action === "add") {
            in_tbl.current.add(obj);
            out_tbl.current.add(obj);
            qc_tbl.current.add(obj);
            !!com_tbl.current && com_tbl.current.add(obj);
        } else if (action === "move") {
            in_tbl.current.move(obj);
            out_tbl.current.move(obj);
            qc_tbl.current.move(obj);
            !!com_tbl.current && com_tbl.current.move(obj);
        } else if (action === "remove") {
            in_tbl.current.remove(obj);
            out_tbl.current.remove(obj);
            qc_tbl.current.remove(obj);
        } else if (action === "copy") {
            in_tbl.current.copy(obj);
            out_tbl.current.copy(obj);
            qc_tbl.current.copy(obj);
        } else if (action === "reset") {
            in_tbl.current.reset(obj);
            out_tbl.current.reset(obj);
            qc_tbl.current.reset(obj);
        }
    };

    const OnClickSO = (index) => {
        SetSelectedSO(index);
    };

    const RevInfo = (maxRevision) => {
        let revList = [];
        for (let i = 1; i <= maxRevision; i++) {
            revList = [...revList, { value: i, label: i }];
        }
        /* Temp Y 일 경우 따로 처리 20241203 우재원 */
        if (tmp.current) {
            revList.push({ value: maxRevision + "T", label: maxRevision, temp: "Y" })
        }
        SetRevList((d) => [...revList]);

        SetRevItem((d) => rev.current + (tmp.current === 'Y' ? "T" : ""));
    };

    const handleReviewOpen = (cellData, uniqueCode) => {
        const search = new URLSearchParams(window.location.search);
        mid.current = search.get("mid");
        rev.current = search.get("rev") || 0;

        let celNm = cellData.name;

        if (cellData.name === "unit2") {
            celNm = cellData.revCelNm;
        } else {
            celNm = cellData.name;
        }
        setRevInputs({
            sheetCode: mid.current,
            revision: rev.current,
            uniqueCode: uniqueCode,
            celNm: celNm,
            userId: userSelector.userId,
            tempYn: tmp.current,
            sheetOwner: inputs.userId,
            revType: cellData.revType,
        });

        if (isUpdate2.current && copyRef.current !== "Y") {
            SetReview(true);
            /*            if (cellData.name !== "paraCd") {
            
                        } else {
                            SetReview(false);
                        }*/
        }
    };

    const in_tbl = useRef(null);
    const out_tbl = useRef(null);
    const qc_tbl = useRef(null);
    const com_tbl = useRef(null);

    const SaveFormData = async ({ msg = "", temp = false }) => {
        dispatch({ type: "LOADING_ON" });
        try {
            const master = validationMaster(inputs, temp);
            master.revisionLog = msg;
            master.message = msg;
            master.webContent = quillRef.current.getValue();

            const sub = validationSub({ master, sub: SOParams }, temp);

            const in_d = validationData(
                {
                    master,
                    sub,
                    data: in_tbl.current.getTableData(),
                },
                "I",
                temp
            );
            const out_d = validationData(
                {
                    master,
                    sub,
                    data: out_tbl.current.getTableData(),
                },
                "O",
                temp
            );
            const qc_d = validationData(
                {
                    master,
                    sub,
                    data: qc_tbl.current.getTableData(),
                },
                "Q",
                temp
            );
            const com_d = validationData2(
                {
                    master,
                    sub,
                    data: com_tbl.current.getTableData(),
                },
                "C",
                temp
            );

            let header;

            header = {
                ...in_tbl.current.getHeaderData(),
                ...out_tbl.current.getHeaderData(),
                ...qc_tbl.current.getHeaderData(),
            };
            let data = {
                master,
                sub,
                header,
                in: in_d,
                out: out_d,  
                qc: qc_d,
                composition: com_d,
            };
            const url = temp ? "/pcsCreate/createSheetMasterTemp" : "/pcsCreate/createSheetMaster";
            const formData = new FormData();
            formData.append("data", JSON.stringify(data));
            const files = FileDragDropRef?.current?.getFiles();
            if (files?.length > 0 && files !== null && files !== undefined) {
                formData.append("fileFlag", "TRUE");
                files.forEach((f, i) => {
                    formData.append(`file[${i}]`, f);
                });
            }

            const response = await axios
                .post(process.env.REACT_APP_API + url, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((Response) => Response.data.data)
                .catch((Error) => {
                    SetModalMsg(<p style={{ textAlign: "center" }}>{Error.toString()}</p>);
                    SetModalOpen(true);
                });
            if (response.result.toString() === "1") {
                if (temp) {
                    mid.current = response.sheetCode;
                    rev.current = response.revision || 0;
                    tmp.current = "Y";
                    setInputs((t) => master);
                    HandleTempSaveOpen();
                } else {
                    const mid = response.sheetCode;
                    const rev = response.revision || 0;
                    const url = "/detail?mid=" + mid + "&rev=" + rev + "&tempYn=N";
                    window.location.replace(url);
                }

                const search = new URLSearchParams(window.location.search);
                let sheetCode = ""
                if (search.get("copy") === "Y") {
                    sheetCode = "tempsheet"
                } else {
                    sheetCode = mid.current ?? "tempsheet"
                }
                // truncateStore(sheetCode)
                deleteDatabase(sheetCode)

            } else if (response.result.toString() === "MSG101") {
                SetWaitModal(
                    <Modal
                        onClose={() => {
                            const mid = response.sheetCode;
                            const rev = response.revision || 0;
                            const url = "/detail?mid=" + mid + "&rev=" + rev + "&tempYn=N";
                            window.location.replace(url);
                        }}
                    >
                        <p style={{ textAlign: "center" }}>{t(response.result.toString())}</p>
                    </Modal>
                );

                const search = new URLSearchParams(window.location.search);
                const mid = search.get("mid");
                let sheetCode = ""
                if (search.get("copy") === "Y") {
                    sheetCode = "tempsheet"
                } else {
                    sheetCode = mid ?? "tempsheet"
                }
                // truncateStore(sheetCode)
                deleteDatabase(sheetCode)
            } else {
                SetModalMsg(<p style={{ textAlign: "center" }}>{t(response.result.toString())}</p>);
                SetModalOpen(true);
            }
        } catch (e) {
            console.error(e);
            SetModalMsg(<p style={{ textAlign: "center" }}>{t(e?.message?.toString())}</p>);
            SetModalOpen(true);
        }
        dispatch({ type: "LOADING_OFF" });
    };

    // 자동저장
    const saveDB = useCallback(async ({ msg = "", temp = true }) => {
        dispatch({ type: "LOADING_ON" });
        try {
            const master = interValMaster(inputs, temp);
            master.revisionLog = msg;
            master.message = msg;
            master.webContent = quillRef.current.getValue();
            master.readyYn = indexDBParam.readyYn;

            const sub = validationSub({ master, sub: SOParams }, temp);

            const in_d = validationData(
                {
                    master,
                    sub,
                    data: in_tbl.current.getTableData(),
                },
                "I",
                temp
            );
            const out_d = validationData(
                {
                    master,
                    sub,
                    data: out_tbl.current.getTableData(),
                },
                "O",
                temp
            );
            const qc_d = validationData(
                {
                    master,
                    sub,
                    data: qc_tbl.current.getTableData(),
                },
                "Q",
                temp
            );
            const com_d = validationData2(
                {
                    master,
                    sub,
                    data: com_tbl.current.getTableData(),
                },
                "C",
                temp
            );

            let header;

            header = {
                ...in_tbl.current.getHeaderData(),
                ...out_tbl.current.getHeaderData(),
                ...qc_tbl.current.getHeaderData(),
            };


            const metadata = [
                { master: 'master', data: master },
                { sub: 'sub', data: sub },
                { header: 'header', data: header },
                { in: 'in', data: in_d, },
                { out: 'out', data: out_d, },
                { qc: 'qc', data: qc_d, },
                { composition: 'composition', data: com_d, }
            ];

            // const search = new URLSearchParams(window.location.search);
            const search = new URLSearchParams(window.location.search);
            const mid = search.get("mid");
            let sheetCode = ""
            if (search.get("copy") === "Y") {
                sheetCode = "tempsheet"
            } else {
                sheetCode = mid ?? "tempsheet"
            }

            addStore(sheetCode, metadata, true);

        } catch (e) {
            console.error(e);
            SetModalMsg(<p style={{ textAlign: "center" }}>{t(e?.message?.toString())}</p>);
            SetModalOpen(true);
        }
        dispatch({ type: "LOADING_OFF" });
    }, [inputs, SOParams]);

    const selectDB = async (storename, { master_t, sub_t, in_t, out_t, qc_t, com_t, revInfo, fileInfo, isCopy, userId }) => {
        const result = await selectAll(storename);

        if (result.length > 0) {
            const confirmDom = (
                <ConfirmIndexDB
                    onClose={() => changeConfirm(storename)}
                    onConfirm={() => indexDBConfirm(storename, { master_t, sub_t, in_t, out_t, qc_t, com_t, revInfo, fileInfo, isCopy, userId })}>
                    <p>There is temporarily stored data. Do you want to apply?</p>
                </ConfirmIndexDB>
            );
            SetConfirmDom(confirmDom);

            return 0;
        } else return 0;
    };

    const changeConfirm = async (storename) => {
        SetConfirmDom(null)
        // truncateStore(storename)
        deleteDatabase(storename)
    }

    const indexDBConfirm = async (storename, { master_t, sub_t, in_t, out_t, qc_t, com_t, revInfo, fileInfo, isCopy, userId }) => {

        const result = await selectAll(storename);
        let master = result[0]?.data ?? {};
        let sub = result[1]?.data ?? [];
        let header = result[2]?.data ?? {};
        let inTable = result[3]?.data ?? [];
        let out = result[4]?.data ?? [];
        let qc = result[5]?.data ?? [];
        let composition = result[6]?.data ?? [];

        master.readyYn = indexDBParam.readyYn;
        let m = { ...master };
        let s = [];
        sub.forEach((v, i) => {
            s = [
                ...s,
                {
                    ...v,
                    code: v.soCode,
                    label: v.soNm,
                    desc: v.description,
                    repeat: v.repeat,
                    // soSeq: v.soSeq,
                },
            ];
        });
        master_t((v) => ({ ...m }));
        sub_t(s);
        com_t({ data: composition, header: header });
        in_t({ data: inTable, header: header, isCopy: isCopy });
        out_t({ data: out, header: header, isCopy: isCopy });
        qc_t({ data: qc, header: header });
        revInfo(m.revision);
        isUpdate2.current = true;
        const search = new URLSearchParams(window.location.search);
        if (search.size === 0) {
            copyRef.current = "Y";
        }
        return 1;

    };

    const validationMaster = (data, temp) => {
        const validation = validationList.master;
        let flag = true;
        let rd = {};
        for (const [k, v] of Object.entries(data)) {
            if (validation.includes(k)) {
                if (!!!v) {
                    flag = false;
                    break;
                }
            }
            rd = { ...rd, [k]: v };
        }
        if (rev.current === null || rev.current === undefined) {
            rev.current = 0;
        }

        const search = new URLSearchParams(window.location.search);
        if (search.get("copy") === "Y") {
            rd.sheetCode = "";
            rd.revision = temp ? 0 : 1;
        } else {
            rd.revision = temp ? parseInt(rev.current) : parseInt(rev.current) + 1;
            rd.sheetCode = mid.current;
        }
        rd.revisionLog = "";
        if (!flag) {
            throw new Error(t("invalidSave1"));
        } else {
            let uid;
            if (copyRef.current === "Y" || !isUpdate2.current) {
                uid = userSelector.userId;
            } else {
                uid = inputs.userId || userSelector.userId;
            }
            rd.userId = uid;
            return rd;
        }
    };

    const interValMaster = (data, temp) => {
        const validation = interValList.master;
        let flag = true;
        let rd = {};
        for (const [k, v] of Object.entries(data)) {
            if (validation.includes(k)) {
                if (!!!v) {
                    // flag = false;
                    break;
                }
            }
            rd = { ...rd, [k]: v };
        }
        if (rev.current === null || rev.current === undefined) {
            rev.current = 0;
        }

        const search = new URLSearchParams(window.location.search);
        if (search.get("copy") === "Y") {
            rd.sheetCode = "";
            rd.revision = temp ? 0 : 1;
        } else {
            rd.revision = temp ? parseInt(rev.current) : parseInt(rev.current) + 1;
            rd.sheetCode = mid.current;
        }
        rd.revisionLog = "";
        if (!flag) {
            throw new Error(t("invalidSave1"));
        } else {
            let uid;
            if (copyRef.current === "Y" || !isUpdate2.current) {
                uid = userSelector.userId;
            } else {
                uid = inputs.userId || userSelector.userId;
            }
            rd.userId = uid;
            return rd;
        }
    };

    const renderRevLog = useMemo(() => {
        if (!RevLogOpen) return null;
        else
            return (
                <ModalPortal>
                    <RevLog
                        onClose={() => SetRevLogOpen(false)}
                        data={{
                            sheetcd: inputs.sheetCode,
                            revision: parseInt(RevItem),
                        }}
                    ></RevLog>
                </ModalPortal>
            );
    }, [RevLogOpen, RevItem]);

    const renderRev = useMemo(() => {
        if (!RevOpen) return null;
        else
            return (
                <ModalPortal>
                    <Rev onClose={() => SetRevOpen(false)} data={inputs.sheetCode}></Rev>
                </ModalPortal>
            );
    }, [RevOpen]);

    const CopySheet = () => {
        window.location.href = "/mainForm?mid=" + mid.current + "&rev=" + rev.current + "&tempYn=" + tmp.current + "&copy=Y";
        // navigate();
    };

    const DownloadWord = async () => {
        dispatch({ type: "LOADING_ON" });
        const filename = inputs.projectNm + "_" + inputs?.mbrNo + "_rev" + inputs.revision + ".docx";
        const response = await axios({
            url: process.env.REACT_APP_API + "/pcsCreate/createWordFile",
            data: {
                sheetcd: inputs.sheetCode,
                revision: inputs.revision,
                tempYn: tmp.current,
            },
            method: "POST",
            responseType: "blob",
        });
        const blob = new Blob([response.data]);

        const fileObjectUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = fileObjectUrl;
        link.style.display = "none";

        link.download = filename;

        document.body.appendChild(link);
        dispatch({ type: "LOADING_OFF" });
        link.click();
        link.remove();

        window.URL.revokeObjectURL(fileObjectUrl);
    };

    const excelDownload = async () => {
        const postData = {
            sheetCode: inputs.sheetCode,
            revision: inputs.revision,
            tempYn: tmp.current,
            projectNm: inputs.projectNm,
            mbrNo: inputs.mbrNo,
            processCd: inputs.processCd
        }
        const excelName = inputs.projectNm + "_" + inputs?.mbrNo + "_rev" + inputs.revision + ".xlsx";
        await DownloadFile({ api: "/pcsCreate/downloadExcelSheetReady", body: postData, name: excelName },)
        window.location.reload();
    }

    const removeTemp = async (memo) => {
        const formData = {
            sheetCode: mid.current,
            tempYn: tmp.current,
            userId: userSelector.userId,
            memo: memo,
            message: memo,
        };
        dispatch({ type: "LOADING_ON" });
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/pcsModify/removeSheetTemp", formData);
            window.history.go(-1);
        } catch (e) {
            console.error(e);
        } finally {
            dispatch({ type: "LOADING_OFF" });
        }
    };

    const confirmValid2 = () => {
        let failed = false;
        const el = document.getElementById("saveMsg");
        if (!!el.value) {
            failed = true;
        }
        return failed;
    };

    const onConfirm2 = () => {
        const el = document.getElementById("saveMsg");
        removeTemp(el.value);
    };

    const revHandelChange = (e) => {
        /* Temp 선택 시 따로 처리 20241203 우재원 */
        if (e.temp === "Y") {
            window.open("/detail?mid=" + mid.current + "&rev=" + e.value.replaceAll(/[^0-9]*/g, '') + "&tempYn=Y", "_blank");
        } else {
            window.open("/detail?mid=" + mid.current + "&rev=" + e.value + "&tempYn=N", "_blank");
        }
        //SetRevItem(e.value);
    };

    const readyClick = async (readyYn) => {
        try {
            let result = "1";
            if (readyYn === "Y") {
                readyYn = "N";
                result = "1";
            } else {
                readyYn = "Y";
                if (tmp.current === "Y") {
                    const temp = true;
                    const master = validationMaster(inputs, temp);
                    master.webContent = quillRef.current.getValue();

                    const sub = validationSub({ master, sub: SOParams }, temp);

                    const in_d = validationData(
                        {
                            master,
                            sub,
                            data: in_tbl.current.getTableData(),
                        },
                        "I",
                        temp
                    );
                    const out_d = validationData(
                        {
                            master,
                            sub,
                            data: out_tbl.current.getTableData(),
                        },
                        "O",
                        temp
                    );
                    const qc_d = validationData(
                        {
                            master,
                            sub,
                            data: qc_tbl.current.getTableData(),
                        },
                        "Q",
                        temp
                    );
                    const com_d = validationData2(
                        {
                            master,
                            sub,
                            data: com_tbl.current.getTableData(),
                        },
                        "C",
                        temp
                    );

                    let header;

                    header = {
                        ...in_tbl.current.getHeaderData(),
                        ...out_tbl.current.getHeaderData(),
                        ...qc_tbl.current.getHeaderData(),
                    };
                    let data = {
                        master,
                        sub,
                        header,
                        in: in_d,
                        out: out_d,
                        qc: qc_d,
                        composition: com_d,
                    };
                    const url = "/pcsCreate/createSheetMasterTemp";
                    const formData = new FormData();
                    formData.append("data", JSON.stringify(data));
                    const response = await axios
                        .post(process.env.REACT_APP_API + url, formData, {
                            headers: { "Content-Type": "multipart/form-data" },
                        })
                        .then((Response) => Response.data.data)
                        .catch((Error) => {
                            SetModalMsg(<p style={{ textAlign: "center" }}>{Error.toString()}</p>);
                            SetModalOpen(true);
                        });
                    result = response.result.toString();
                }
            }
            if (result === "1") {
                readyValidationData({ data: in_tbl.current.getTableData() });
                readyValidationData({ data: out_tbl.current.getTableData() });

                const response = await axios
                    .post(process.env.REACT_APP_API + "/pcsCreate/saveSheetReady",
                        {
                            "readyYn": readyYn,
                            "tempYn": tmp.current,
                            "sheetCode": mid.current,
                            "revision": rev.current,
                            "userId": userSelector.userId,
                            "projectNm": inputs.projectNm,
                            "mbrNo": inputs.mbrNo,
                            "processCd": inputs.processCd,
                        }
                    )
                    .then((Response) => Response.data.data)
                    .catch((Error) => {
                        SetModalMsg(<p style={{ textAlign: "center" }}>{Error.toString()}</p>);
                        SetModalOpen(true);
                    });
                if (response.result === "ERR108") {
                    SetModalMsg(<p style={{ textAlign: "center" }}>{t("ERR108")}</p>);
                    SetModalOpen(true);
                    return;
                }
            }

            let search = new URLSearchParams(window.location.search);
            let sheetCode = ""
            if (search.get("copy") === "Y") {
                sheetCode = "tempsheet"
            } else {
                sheetCode = mid.current ?? "tempsheet"
            }
            // truncateStore(sheetCode)
            deleteDatabase(sheetCode)

            window.location.replace("/mainForm?mid=" + mid.current + "&rev=" + rev.current + "&tempYn=" + tmp.current);


        } catch (e) {
            SetModalMsg(<p style={{ textAlign: "center" }}>{t(e?.message?.toString())}</p>);
            SetModalOpen(true);
        }

    }

    const timerRef = useRef(null);
    const idleTime = 60*5000; // 5min

    useEffect(() => {

        const handleActivity = () => {
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(async () => {
                await SaveFormData({
                    temp: true,
                })
            }, idleTime);
        };

        //감지이벤트
        const events = ["mousemove", "keydown", "click", "scroll", "visibilitychange"];
        events.forEach((event) => window.addEventListener(event, handleActivity));

        // 페이지 로드시 타이머 시작
        handleActivity();

        return () => {
            clearTimeout(timerRef.current);
            events.forEach((event) => window.removeEventListener(event, handleActivity));
        }

    }, [inputs,SOParams]);



    // useEffect(() => {
    //     let _indexDB;
    //
    //     if (indexDB) {
    //         _indexDB = setInterval(() => {
    //             saveDB({ temp: true })
    //         }, 60 * 5000)
    //     } else clearInterval(_indexDB);
    //     return () => clearInterval(_indexDB);
    // }, [indexDB, saveDB])

    // useEffect(() => {
    //     if (!indexDB) {
    //         const search = new URLSearchParams(window.location.search);
    //         const mid = search.get("mid");
    //         let sheetCode = ""
    //         if (search.get("copy") === "Y") {
    //             sheetCode = "tempsheet"
    //         } else {
    //             sheetCode = mid ?? "tempsheet"
    //         }
    //         // truncateStore(sheetCode)
    //         deleteDatabase(sheetCode)
    //     }
    // }, [indexDB])

    /*1px solid #ccc*/
    return (
        <div className="bpl-container" style={{ paddingBottom: "300px" }}>
            <section className="create">
                <div className="info_top">
                    {/*<button onClick={saveDB}>저장DB</button>*/}
                    {/*<button onClick={deleteDatabase}>db삭제</button>*/}
                    {/*<button onClick={() => {*/}
                    {/*    setIndexDB(!indexDB);*/}
                    {/*}}>체크</button>*/}
                    <table id="head-table">
                        <colgroup>
                            <col width="100" />
                            <col width="100" />
                            <col width="100" />
                            <col width="100" />
                            <col width="350" />
                            <col />
                            <col width="80" />
                            {/* <col width="130" /> */}
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Plant</th>
                                <th>Project</th>
                                <th>MBR No</th>
                                <th>Process</th>
                                <th>Unit Operation</th>
                                <th>Unit Description</th>
                                <th>Cycle</th>
                                {/* <th>Stage</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {
                                    isUpdate ?
                                        <td>{inputs.plant} </td>
                                        : <td><SearchableSelect
                                            name="plant"
                                            value={inputs.plant}
                                            options={MasterOPTS.PLANT}
                                            isDisabled={isUpdate}
                                            onChange={(val) => {
                                                onChangeInputHandler({
                                                    target: {
                                                        name: "plant",
                                                        value: val.value,
                                                    },
                                                });
                                            }}
                                        />
                                        </td>
                                }
                                {
                                    isUpdate ?
                                        <td>{inputs.projectNm} </td>
                                        : <td>
                                            <SearchableSelect
                                                name="projectNm"
                                                value={inputs.projectNm}
                                                search={true}
                                                options={MasterOPTS.PROJECT}
                                                isDisabled={isUpdate}
                                                onChange={(val) => {
                                                    onChangeInputHandler({
                                                        target: {
                                                            name: "projectNm",
                                                            value: val.value,
                                                        },
                                                    });
                                                }}
                                            />
                                        </td>
                                }
                                {isUpdate ? <td>{inputs.mbrNo} </td> :
                                    <td>
                                        <SearchableSelect
                                            name="mbrNo"
                                            value={inputs?.mbrNo}
                                            search={true}
                                            options={MasterOPTS.MBRNO}
                                            isDisabled={isUpdate}
                                            onChange={(val) => {
                                                onChangeInputHandler({
                                                    target: {
                                                        name: "mbrNo",
                                                        value: val.value,
                                                    },
                                                });
                                            }}
                                        />
                                    </td>
                                }
                                <td>
                                    <input type="hidden" id="processCd" value={inputs.processCd} />
                                    <SearchableSelect
                                        name="processCd"
                                        search={false}
                                        options={PRList}
                                        value={inputs.processCd}
                                        isDisabled={isUpdate}
                                        onChange={(val) => {
                                            if (inputs.processCd !== val.value) {
                                                onChangeInputHandler({
                                                    target: {
                                                        name: "processCd",
                                                        value: val.value,
                                                    },
                                                });
                                                onChangeInputHandler({
                                                    target: {
                                                        name: "unitCd",
                                                        value: "",
                                                    },
                                                });
                                            }
                                        }}
                                    />
                                </td>
                                <td>
                                    <SearchableSelect
                                        name="unitCd"
                                        search={true}
                                        options={UOList}
                                        value={inputs.unitCd}
                                        isDisabled={isUpdate}
                                        onChange={(val) => {
                                            onChangeInputHandler({
                                                target: {
                                                    name: "unitCd",
                                                    value: val.value,
                                                },
                                            });
                                        }}
                                    />
                                </td>
                                <td style={{ overflow: "hidden", position: "relative" }}>
                                    <CustomInput
                                        type="text"
                                        name="description"
                                        placeholder="Description"
                                        value={inputs.description}
                                        onChange={onChangeInputHandler}
                                    />
                                </td>

                                <td
                                    className={inputs.processCd === "DSP" ? "" : "readonly"}
                                    style={{
                                        overflow: "hidden",
                                        position: "relative",
                                        textAlign: "right",
                                    }}
                                >
                                    <CustomInput
                                        type="text"
                                        name="cycle"
                                        placeholder="Cycle"
                                        value={inputs.cycle}
                                        readOnly={inputs.processCd !== "DSP"}
                                        style={{
                                            textAlign: "right",
                                            paddingRight: "20px",
                                        }}
                                        onChange={onChangeInputHandler}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {inputs.readyYn === "Y" ? <div style={{ float: "right", color: "red" }}><h2>READY</h2></div> : ""}
                </div>

                <div className={"info_middle cf " + (Hide ? "hide" : "")}>
                    <h1 className={"title "} onClick={() => SetHide(!Hide)}>
                        <FontAwesomeIcon icon={faAngleUp} />
                    </h1>
                    <div className={"so-section "}>
                        <div className="left">
                            <SOTable
                                ref={soRef}
                                onChg={changeSO}
                                onChangeListener={changeSOListner}
                                up={isUpdate2.current}
                                unit={inputs.unitCd}
                                pr={inputs.processCd}
                                cycle={inputs.cycle}
                                onOpen={handleReviewOpen}
                                soSelected={soSelected}
                                setSoSelected={setSoSelected}
                                handleClickSQTable={handleClickSQTable}
                                RevCmptCheckList={RevCmptCheckList}
                                isCopy={copyRef.current}
                                isSheetCode={mid.current}
                            />
                        </div>

                        <div className="right">
                            <div className="revision">
                                <div className="re_top">
                                    <h4>Revision</h4>
                                    {RevList.length > 0 && (
                                        <div className="re_btn" onClick={() => SetRevOpen(true)}>
                                            Rev.History
                                        </div>
                                    )}
                                </div>

                                <div className="re_bottom">
                                    {RevList.length > 0 ? (
                                        <>
                                            <div className="re_left text-center">
                                                {/*{RevList[RevList.length-1].label}*/}
                                                <SearchableSelect
                                                    name="rev_history"
                                                    search={false}
                                                    options={RevList}
                                                    value={RevItem}
                                                    textAlign="center"
                                                    arrow={true}
                                                    revision={true}
                                                    onChange={(e) => {
                                                        revHandelChange(e);
                                                    }}
                                                />
                                            </div>
                                            <div className="re_right">
                                                {
                                                    !RevItem.toString().match(/[0-9]T/) && <div onClick={() => SetRevLogOpen(true)} className="log_btn">
                                                        LOG
                                                    </div>
                                                }

                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <p
                                                style={{
                                                    textAlign: "center",
                                                    padding: "5px",
                                                }}
                                            >
                                                No Revision
                                            </p>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="info_bottom">
                    <div className="left">
                        {/* <ul className="arrow">
                            <li onClick={() => ScrollMove("left")}>{"<"}</li>
                        </ul> */}
                        <ul className="tap" ref={ScrollRef}>
                            <li
                                className={"allSO " + (SelectedSO === SOParams.length - 1 ? "on" : "")}
                                onClick={() => OnClickSO(SOParams.length - 1)}
                            >
                                ALL
                            </li>
                            {SOParams.map((v, i) => {
                                if (i >= SOParams.length - 1) return null;
                                return (
                                    <li key={i} className={SelectedSO === i ? "on" : ""} onClick={() => OnClickSO(i)}>
                                        {v.desc}
                                    </li>
                                );
                            })}
                        </ul>
                        {/* <ul className="arrow">
                            <li onClick={() => ScrollMove("right")}>{">"}</li>
                        </ul> */}
                    </div>

                    {(inputs.userId === userSelector.userId ||
                        !!!inputs.userId ||
                        !isUpdate ||
                        userSelector.isAdmin) && (
                            <>
                                {(copyRef !== "Y" || !inputs?.userId) && (
                                    <div className={"right " + (sheetCompleteState ? "active" : "")} style={{ top: "10%" }}>
                                        <div
                                            className={"completed_box"}
                                            style={sheetCompleteState ? { opacity: 1, right: 15 } : { opacity: 0, right: "-420px" }}
                                        >
                                            <div
                                                style={{
                                                    border: "1px solid #aaa",
                                                    backgroundColor: "#FFF",
                                                    height: "100%",
                                                    overflow: "auto",
                                                    borderRadius: "8px",
                                                    boxShadow: "1px 1px 5px 1px rgb(185 180 180)",
                                                }}
                                            >
                                                <table className={"completed_table"}>
                                                    <thead
                                                        style={{
                                                            backgroundColor: "#EEEEFF",
                                                            width: "100%",
                                                            position: "sticky",
                                                            top: 0,
                                                            zIndex: 1,
                                                        }}
                                                    >
                                                        <tr>
                                                            <th>Sheet Type</th>
                                                            <th>Step Operation</th>
                                                            <th>Description</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ backgroundColor: "#FFF" }}>
                                                        <CompleteList sheetCompleteList={sheetCompleteList} />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className={"right " + (menuOpenS ? "active" : "")}>
                                    <div className="action_btn">
                                        <div className="ab_relative">
                                            <div className="contain" onClick={() => menuOpen(!menuOpenS)}>
                                                <FontAwesomeIcon icon={faArrowLeft} />
                                            </div>
                                        </div>
                                        <div className="actions">
                                            <ul className="work_btn">
                                                {(userSelector.isAdmin ||
                                                    userSelector.isWriter ||
                                                    userSelector.userId === inputs.userId) &&
                                                    copyRef.current !== "Y" &&
                                                    inputs?.userId && (
                                                        <li onClick={() => setSheetCompleteState(!sheetCompleteState)}>
                                                            {t("unconfirmedList")}
                                                        </li>
                                                    )}

                                                {isUpdate2.current && copyRef.current !== "Y" &&
                                                    <li onClick={CopySheet}>Copy</li>}

                                                {(userSelector.isAdmin ||
                                                    userSelector.isWriter ||
                                                    userSelector.userId === inputs.userId) && (
                                                        <>
                                                            <li
                                                                onClick={() =>
                                                                    SaveFormData({
                                                                        temp: true,
                                                                    })
                                                                }
                                                            >
                                                                Save
                                                            </li>
                                                            {/*<li onClick={() => saveDB({ temp: true, })}>*/}
                                                            {/*    {t("saveDB")}*/}
                                                            {/*</li>*/}
                                                            {/*<li onClick={() => selectDB()}>*/}
                                                            {/*    {t("selectDB")}*/}
                                                            {/*</li>*/}
                                                            {/*<li onClick={() => deleteDB()}>*/}
                                                            {/*    {t("deleteDB")}*/}
                                                            {/*</li>*/}
                                                            <li onClick={() => SetConfirmOpen(true)}>Confirm</li>
                                                            <li style={{ display: "none" }} onClick={() => setIndexDB(!indexDB)}>Auto Save {indexDB ? "ON" : "OFF"}</li>
                                                        </>
                                                    )}

                                                {/*{isUpdate2.current && copyRef.current !== "Y" && (*/}
                                                {/*    <li className="f_do" onClick={DownloadWord}>*/}
                                                {/*        Download Word File*/}
                                                {/*    </li>*/}
                                                {/*)}*/}
                                                {inputs.readyYn === "Y" && (inputs.userId === userSelector.userId) && (
                                                    <li className="f_do" onClick={excelDownload}>
                                                        Excel Download
                                                    </li>
                                                )}
                                                {copyRef.current !== 'Y' && mid.current &&
                                                    <li className="f_do" onClick={() => readyClick(inputs.readyYn)}>
                                                        READY {inputs.readyYn === "Y" ? <FontAwesomeIcon icon={faToggleOn} style={{ fontSize: "1rem", color: "#6300ff" }} /> : <FontAwesomeIcon icon={faToggleOff} style={{ fontSize: "1rem", color: "#6300ff" }} />}
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                </div>
                {/* <div className="d-none">
                    <input type="file" ref={FileInput} onChange={FileChangeHandler} />
                </div> */}
            </section>
            <Editor ref={quillRef} webContent={inputs.webContent} reviewData={RevCmptCheckList} onOpen={handleReviewOpen} />
            <COMTable
                ref={com_tbl}
                RevCmptCheckList={RevCmptCheckList}
                so={SOParams}
                sso={SelectedSO}
                unitCd={inputs.unitCd}
                PData={null}
                onOpen={handleReviewOpen}
                remarkList={remarkList}
                updateRemarkList={updateRemarkList}
            />
            <InTable
                ref={in_tbl}
                RevCmptCheckList={RevCmptCheckList}
                so={SOParams}
                sso={SelectedSO}
                setso={remarkSO}
                onOpen={handleReviewOpen}
                remarkList={remarkList}
                updateRemarkList={updateRemarkList}
            />

            <OutTable
                ref={out_tbl}
                RevCmptCheckList={RevCmptCheckList}
                so={SOParams}
                sso={SelectedSO}
                setso={remarkSO}
                PROCode={inputs.processCd}
                onOpen={handleReviewOpen}
                remarkList={remarkList}
                updateRemarkList={updateRemarkList}
            />
            <QCTable
                ref={qc_tbl}
                RevCmptCheckList={RevCmptCheckList}
                so={SOParams}
                sso={SelectedSO}
                setso={remarkSO}
                PROCode={inputs.processCd}
                onOpen={handleReviewOpen}
                remarkList={remarkList}
                updateRemarkList={updateRemarkList}
            />
            {ModalOpen && (
                <ModalPortal>
                    <Modal onClose={HandleModalOpen}>{ModalMsg}</Modal>
                </ModalPortal>
            )}
            {TempSaveOpen && (
                <ModalPortal>
                    <Modal onClose={HandleTempSaveOpen}>{t("saved")}</Modal>
                </ModalPortal>
            )}
            {renderRev}
            {renderRevLog}
            {ConfirmOpen && (
                <ModalPortal>
                    <Confirm
                        onClose={() => SetConfirmOpen(false)}
                        valid={confirmValid}
                        onConfirm={() => onConfirm(SetConfirmOpen)}
                        autoComplete={false}
                    >
                        <p>
                            {t("saveConfirm")}
                            <br />
                            {t("saveConfirm2")}
                        </p>
                        <textarea id="saveMsg" defaultValue="" onFocus={handleConfirmValid} />
                        <span id="mainFormSaveSpan" className={"valid"}>
                            {t("noReason")}
                        </span>
                        <FileDragDrop ref={FileDragDropRef} />
                    </Confirm>
                </ModalPortal>
            )}
            {ConfirmOpen2 && (
                <ModalPortal>
                    <Confirm onClose={() => SetConfirmOpen2(false)} valid={confirmValid2} onConfirm={() => onConfirm2()}>
                        <p>MEMO</p>
                        <textarea id="saveMsg" defaultValue="" />
                        <span></span>
                    </Confirm>
                </ModalPortal>
            )}
            <DragDiv tdSelector={tdSelector} />
            {Review && (
                <ReviewDiv
                    tdSelector={tdSelector}
                    onClose={() => SetReview(false)}
                    revInputs={revInputs}
                    setRevInputs={setRevInputs}
                    in_tbl={in_tbl}
                    out_tbl={out_tbl}
                    qc_tbl={qc_tbl}
                    com_tbl={com_tbl}
                    setSoSelected={setSoSelected}
                    getRevCmptCheckList={getRevCmptCheckList}
                    revUserList={revUserList}
                    setRevModeCheck={setRevModeCheck}
                    getSheetCompleteList={getSheetCompleteList}
                />
            )}
            {revModeCheck && (
                <ModalPortal>
                    <Modal onClose={() => setRevModeCheck(false)}> {t("cannotReviewWrite")}</Modal>
                </ModalPortal>
            )}
            {WaitModal && <ModalPortal>{WaitModal}</ModalPortal>}
            {ConfirmDom && <ModalPortal>{ConfirmDom}</ModalPortal>}
        </div>
    );
};

const DragDiv = (props) => {
    const { tdSelector } = props;
    const [visible, setVisible] = useState(true);
    const canMove = useRef(true);
    const handleVisible = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setVisible(!visible);
    };
    const saved = useRef();
    const MO = (e) => {
        if (!!tdSelector.td) {
            saved.current = tdSelector.td;
        }
        if (e.type === "mousedown") {
            onclick(e);
        }
        canMove.current = false;
    };
    const ML = () => {
        canMove.current = true;
    };
    const list1 = ["⁰", "¹", "²", "³", "⁴", "⁵", "⁶", "⁷", "⁸", "⁹", "⁺", "⁻", "⁽", "⁾"];
    const list2 = ["₀", "₁", "₂", "₃", "₄", "₅", "₆", "₇", "₈", "₉", "₊", "₋", "₍", "₎"];
    let tm;
    const onclick = (e) => {
        const value = e.target.dataset.value;
        try {
            if (saved.current?.tagName === "TEXTAREA" && value) {
                saved.current.value = saved.current.value + value;
            } else if (saved.current?.tagName === "DIV" && value) {
                saved.current.innerText = saved.current.innerText + value;
            }
            clearTimeout(tm);
            tm = setTimeout(() => {
                saved.current?.focus();
                saved.current = null;
            }, 100);
        } catch (e) {
            console.error(e);
        }
    };
    // onMouseOver={MO} onMouseLeave={ML} onMouseDown={MO} 지우기
    return (
        <Draggable
            onStart={() => {
                return canMove.current;
            }}
        >
            <div id="ucPanel">
                <div className={"header"} onClick={handleVisible} onMouseOver={MO} onMouseLeave={ML} onMouseDown={MO}>
                    {visible ? (
                        <FontAwesomeIcon icon={faXmark} style={{ color: "var(--danger-color" }} />
                    ) : (
                        <FontAwesomeIcon
                            icon={faArrowUpRightFromSquare}
                            style={{
                                transform: "scaleX(-1)",
                                color: "var(--main-color",
                            }}
                        />
                    )}
                </div>

                <div className={`content ${visible ? "show" : "hidden"}`}>
                    <div className="d-row">
                        {list1.map((v, i) => {
                            return (
                                <div
                                    key={"unicode1_" + i}
                                    className="item"
                                    data-value={"" + v}
                                    onMouseOver={MO}
                                    onMouseLeave={ML}
                                    onMouseDown={MO}
                                >
                                    &nbsp;{v}
                                </div>
                            );
                        })}
                    </div>
                    <div className="d-row">
                        {list2.map((v, i) => {
                            return (
                                <div
                                    key={"unicode2_" + i}
                                    className="item"
                                    data-value={"" + v}
                                    onMouseOver={MO}
                                    onMouseLeave={ML}
                                    onMouseDown={MO}
                                >
                                    &nbsp;{v}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </Draggable>
    );
};

const ReviewDiv = ({
    tdSelector,
    onClose,
    revInputs,
    setRevInputs,
    in_tbl,
    out_tbl,
    qc_tbl,
    com_tbl,
    setSoSelected,
    getRevCmptCheckList,
    revUserList,
    setRevModeCheck,
    getSheetCompleteList,
}) => {
    const [visible, setVisible] = useState(true);
    const canMove = useRef(true);
    const { t } = useTranslation(["page"]);

    const userSelector = useSelector((store) => store.user);
    const externalAuth = userSelector.userAuth.filter((f) => f.code === "20")
    const [reviewList, setReviewList] = useState([]);
    const [userState, setUserState] = useState(false);
    const [userList, setUserList] = useState({ label: "", value: "" });
    const [textAreHtml, setTextAreHtml] = useState({
        revContent: "",
    });
    const [textAreText, setTextAreText] = useState({
        revContent: "",
    });
    const textRef = useRef(null);

    const handleVisible = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setVisible(!visible);
    };

    const getReviewList = useCallback(async () => {
        const response = await axios.post(process.env.REACT_APP_API + "/pcsReview/list", revInputs);
        if (response.status === 200) {
            const resultData = response.data.data.result;
            setReviewList(resultData);
        } else {
            throw new Error("getAxios");
        }
    }, [revInputs]);

    useEffect(() => {
        getReviewList();
    }, [getReviewList]);

    const revSave = () => {
        let externalViewYn
        let externalSend = document.getElementById("externalSend").checked;
        const payload = {
            ...revInputs,
            revContent: textRef.current.innerHTML,
            revLevel: 1,
            externalViewYn: externalSend ? externalViewYn = "Y" : externalViewYn = "N"
        };

        const res = axios
            .post(process.env.REACT_APP_API + "/pcsReview/save", payload)
            .then((Response) => {
                if (Response.data.code === 403) {
                    setRevModeCheck(true);
                } else {
                    getReviewList();
                    textRef.current.innerHTML = "";
                    const reLoadData = {
                        ...revInputs,
                        revContent: "",
                        revLevel: 1,
                    };
                    setUserState(false);
                    setRevInputs(reLoadData);
                    clearTextarea();
                    getRevCmptCheckList({
                        sheetcd: revInputs.sheetCode,
                        revision: revInputs.revision,
                        tempYn: revInputs.tempYn,
                    });
                }
            })
            .catch((e) => console.error(e));
    };

    const revExternalSave = (replyInputs, setReplyInputs) => {
        const res = axios
            .post(process.env.REACT_APP_API + "/pcsReview/externalViewChange", replyInputs)
            .then((Response) => {
                getReviewList();
                const payload = {
                    ...replyInputs,
                    revContent: "",
                };
                setReplyInputs(payload);
                getSheetCompleteList();

                return Response.data.data.result;
            })
            .catch((e) => console.error(e));
    };

    const replySave = (replyInputs, setReplyInputs) => {
        const res = axios
            .post(process.env.REACT_APP_API + "/pcsReview/saveReply", replyInputs)
            .then((Response) => {
                getReviewList();

                const payload = {
                    ...replyInputs,
                    revContent: "",
                };
                setReplyInputs(payload);
                getSheetCompleteList();

                return Response.data.data.result;
            })
            .catch((e) => console.error(e));
    };
    const cmptTypeUpdate = (cmptType, revNo, groupId) => {
        const payload = {
            ...revInputs,
            revNo: revNo,
            cmptType: cmptType,
            groupId: groupId,
        };

        const res = axios
            .post(process.env.REACT_APP_API + "/pcsReview/modifyCmptType", payload)
            .then((Response) => {
                getReviewList();
                getRevCmptCheckList({
                    sheetcd: revInputs.sheetCode,
                    revision: revInputs.revision,
                    tempYn: revInputs.tempYn,
                });
                getSheetCompleteList();
            })
            .catch((e) => console.error(e));
    };
    const onChangetextareaHandler = (e, value) => {
        const payload = {
            ...revInputs,
            revContent: value,
            revLevel: 1,
        };

        setRevInputs(payload);
    };

    const saved = useRef();
    const MO = (e) => {
        if (!!tdSelector.td) {
            saved.current = tdSelector.td;
        }
        if (e.type === "mousedown") {
        }
        canMove.current = false;
    };

    const revShowHide = (e) => {
        /*        com_tbl.current.resetData();
        in_tbl.current.resetData();
        out_tbl.current.resetData();
        qc_tbl.current.resetData();*/
        setSoSelected({ name: "", index: "" });

        onClose();
    };

    const ML = () => {
        canMove.current = true;
    };

    const clearTextarea = () => {
        revInputs.revContent = "";
    };
    const textOnview = (e) => {
        const textData = e.target.innerText;

        let user = revUserList.filter(
            (data) =>
                data.label
                    .toLowerCase()
                    .indexOf(textData.toLowerCase().substring(textData.lastIndexOf("@") + 1, textData.length)) !== -1
        );
        if (
            user.length !== 0 &&
            textData !== "" &&
            textData.substring(textData.lastIndexOf("@"), textData.lastIndexOf("@") + 1) === "@"
        ) {
            setUserState(true);
        } else {
            setUserState(false);
        }
        setUserList(user);
    };
    const userClick = (data) => {
        const revContentHtml = textRef.current.innerHTML;
        const revContentText = textRef.current.innerText;
        const textData = revContentHtml?.substring(revContentHtml.lastIndexOf("@"), -1);

        const payloadHtml = {
            revContent:
                textData +
                '<span suppressContentEditableWarning={true} contentEditable="false" class="bpl-reviewerspan" data-userid="' +
                data.value +
                '">' +
                "@" +
                data.label +
                "</span>",
        };
        setUserState(false);
        setTextAreHtml(payloadHtml);
    };

    // onMouseOver={MO} onMouseLeave={ML} onMouseDown={MO} 지우기
    return (
        <section className="preview">
            <Draggable
                onStart={() => {
                    return canMove.current;
                }}
            >
                <div className="prebox">
                    <div className="preTop" style={{ cursor: "all-scroll" }}>
                        <div className="close" onClick={(e) => revShowHide(e)}>
                            <div className="cc c1"></div>
                            <div className="cc c2"></div>
                        </div>
                    </div>
                    <div className="middle" onMouseOver={MO} onMouseLeave={ML} onMouseDown={MO}>
                        {reviewList.map((data, i) => (
                            <RevData
                                key={`RevData-data-${i}`}
                                data={data}
                                replySave={replySave}
                                cmptTypeUpdate={cmptTypeUpdate}
                                revInputs={revInputs}
                                revUserList={revUserList}
                                revExternalSave={revExternalSave}
                            />
                        ))}
                    </div>
                    {revInputs.tempYn === "Y" && (
                        <div className="bottom" onMouseOver={MO} onMouseLeave={ML} onMouseDown={MO}>
                            <div
                                style={{
                                    position: "relative",
                                    flex: 3,
                                    height: "100%",
                                    marginRight: 10,
                                }}
                            >
                                <div className="box_txa" style={{ padding: 5 }}>
                                    <ComTextarea
                                        ref={textRef}
                                        onview={textOnview}
                                        revInputs={revInputs}
                                        onChangetextareaHandler={onChangetextareaHandler}
                                        textAreHtml={textAreHtml}
                                    />
                                </div>
                                {userState && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "auto",
                                            left: 0,
                                            right: 0,
                                            bottom: "100%",
                                            height: 200,
                                            border: "1px solid #aaa",
                                            background: "white",
                                        }}
                                    >
                                        <UserList user={userList} userClick={userClick} />
                                    </div>
                                )}
                            </div>

                            <div className="btn_box" style={{ flex: 1 }}>
                                <button className="btn" onClick={revSave}>
                                    {t("save")}
                                </button>
                            </div>
                            {externalAuth?.length === 0 ? (
                                <div className={`radio-group`}>
                                    <input
                                        type="checkbox"
                                        id={`externalSend`}
                                    />
                                    <label htmlFor={`externalSend`}>external</label>
                                </div>
                            ) : null
                            }
                        </div>
                    )}
                </div>
            </Draggable>
        </section>
    );
};

export default Create;